import {motion,useReducedMotion} from 'framer-motion';
import '../about-badge.css';

function AboutBadge() {
  const reduce = useReducedMotion();

  return (
    <motion.span
      className="about-badge"
      tabIndex={0}
      initial={reduce ? {opacity: 0} : {opacity: 0, x: -140}}
      whileInView={{opacity: 1, x: 0}}
      viewport={{once: true, amount: 0.8}}
      whileHover={reduce ? undefined : {scale: 1.14}}
      whileFocus={reduce ? undefined : {scale: 1.14}}
      transition={{type: 'spring', stiffness: 120, damping: 16}}
    >
      <strong>30+</strong>
      <span className="about-badge-label">years in motion</span>
    </motion.span>
  );
}

export default AboutBadge;